import React from 'react'
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ListItem,
  Stack,
  Text,
  UnorderedList,
} from 'src/ui'
import { useTicketsContext } from 'src/reports/ticket-applications/context'

function ConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
}: Readonly<{
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  isLoading: boolean
}>) {
  const { detailsIsEditing, gradeFactorsIsEditing } = useTicketsContext()

  const isEditing = detailsIsEditing || gradeFactorsIsEditing

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        {isEditing ? (
          <>
            <ModalHeader>Unsaved Changes</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Stack>
                <Stack>
                  <Text>Updates to the following sections have not been saved:</Text>
                  <UnorderedList>
                    {detailsIsEditing && <ListItem>Details</ListItem>}
                    {gradeFactorsIsEditing && <ListItem>Grade Factors</ListItem>}
                  </UnorderedList>
                </Stack>
                <Text>
                  Please &lsquo;save&rsquo; prior to disabling or your updates will be lost.
                </Text>
              </Stack>
            </ModalBody>
          </>
        ) : (
          <>
            <ModalHeader>Disable Ticket Applications Report</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Text>Are you sure you want to disable the Ticket Applications Report?</Text>
            </ModalBody>
          </>
        )}
        <ModalFooter>
          <Button colorScheme="secondary" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button
            colorScheme="primary"
            onClick={onConfirm}
            isDisabled={isLoading}
            isLoading={isLoading}
          >
            Disable
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default ConfirmationModal
